import { Button, Avatar, Menu, Dropdown, Tooltip, Modal, Alert } from "antd";
import { LogoutOutlined, UserOutlined, QuestionCircleOutlined, DownOutlined, MenuOutlined, WarningTwoTone } from "@ant-design/icons";
import KycModal from "./KycModal";
import { Link } from "react-router-dom";
import defaultAvatar from "../assets/images/avatar.png";
import Marquee from 'react-fast-marquee';
import "./css/navbar.css";
import { useState } from "react";

const { Header } = require("antd/lib/layout/layout");

const NavBar = ({ onOpenSidebar }) => {
  const authUser = JSON.parse(sessionStorage.getItem("authUser"));
  const twoFaEnabled = authUser?.user?.twoFaEnabled;
  const kycVerified = authUser?.kycVerified;
  const user = `${authUser?.user?.firstName ?? ""} ${authUser?.user?.lastName ?? ""}`.trim() || authUser?.user?.username;

  const [isOpenModal, setIsOpenModal] = useState(false);

  const closeModal = () => {
    setIsOpenModal(false);
  }

  const handleOk = () => {
    console.log("Data sent ...");
    setIsOpenModal(false);
  }

  const handleCancel = () => {
    console.log("Cancel send Data ...");
    setIsOpenModal(false);
  }

  const userMenu = (
    <Menu>
      <div className="text-center mt-2">
        <Avatar size={35} src={authUser?.user?.fileName || defaultAvatar} />
      </div>
      <p className="user-name-center">
        <strong>{authUser?.user?.firstName} {authUser?.user?.lastName}</strong>
      </p>
      <p className="user-email-center">{authUser?.user?.email}</p>
      <Menu.Item key="profile" icon={<UserOutlined />} disabled = {!kycVerified}>
        <Link to="/profile">Mon profil</Link>
      </Menu.Item>
      <Menu.Item key="help" icon={<QuestionCircleOutlined />}>
        Aide
      </Menu.Item>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <Link to="/logout">Se déconnecter</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Header className="navbar-header col-12 col-md-12 col-md-12">
      <div className="d-md-none">
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={onOpenSidebar}
          style={{ fontSize: '20px' }}
        />
      </div>

      <div className="d-flex justify-content-end gap-2 w-100">
  
        {kycVerified && !twoFaEnabled && (
          <>
            <Alert
              className="demon-alert-2FA"
              banner
              message={
                <Marquee pauseOnHover gradient={false}>
                  Pour plus de sécurité, Appliquer dès maintenant la double authentification dans vos transactions. {" "}
                </Marquee>
              }
            />

            <Button
              className="auth-double"
              onClick={() => (window.location.href = "/profile?tab=doubleAuth")}
            >
              <WarningTwoTone twoToneColor="#fff" style={{ fontSize: 18 }} />
              <span>2FA désactivé</span>
            </Button>
          </>
        )}
        {!kycVerified && (
          <>
            <Alert
              className="demon-alert-2FA"
              banner
              message={
                <Marquee pauseOnHover gradient={false}>
                  Chez Paxity votre securité est notre priorité. Merci de renseigner vos documents conformes afin qu'on vous identifie. {" "}
                </Marquee>
              }
            />
          </>
        )}

        {/* {!kycVerified && (
          <Tooltip title="Veuillez renseigner vos documents d’identification pour finaliser la vérification KYC.">
            <Button
              className="auth-double"
              onClick={() => setIsOpenModal(true)}
            >
              <WarningTwoTone twoToneColor="#fff" style={{ fontSize: 18 }} />
              <span>Identification requise</span>
            </Button>
          </Tooltip>
        )} */}

      </div>

      <div className="navbar-right">
        <Dropdown overlay={userMenu} trigger={['click']}>
          <div className="avatar-name">
            <>
              <Avatar size={35} src={authUser?.user?.fileName || defaultAvatar} />
            </>
            <span className="username-text">
              {user} <DownOutlined />
            </span>
          </div>
        </Dropdown>
      </div>

      <Modal
        closable={{ 'aria-label': 'Custom Close Button' }}
        footer={false}
        open={isOpenModal}
        onOk={handleOk}
        onCancel={handleCancel}>
        <KycModal closeModal={closeModal} />
      </Modal>
    </Header>
  );
};

export default NavBar;
